import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1); // State for quantity
  const [showDescription, setShowDescription] = useState(false); // State for description toggle

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(`https://kothari-international-server.onrender.com/api/products/${productId}`);
        if (!response.ok) {
          throw new Error(`Product not found (status: ${response.status})`);
        }
        const foundProduct = await response.json();
        setProduct(foundProduct);
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [productId]);

  const addToCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const existingItemIndex = cart.findIndex((item) => item.id === product.id);

    if (existingItemIndex !== -1) {
      // Update quantity if item exists
      cart[existingItemIndex].quantity += quantity;
    } else {
      // Add new item with specified quantity
      cart.push({ ...product, quantity });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    // Dispatch custom event to notify cart update
    window.dispatchEvent(new Event("storageUpdate"));
    alert(`${product.name} (${quantity}) added to cart!`);
  };

  const handleQuantityChange = (change) => {
    setQuantity((prev) => Math.max(1, prev + change)); // Prevent quantity < 1
  };

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (!product) return <p className="not-found">Product not found.</p>;

  return (
    <div className="product-details">
      <div className="product-details__card">
        <div className="product-details__image-container">
          <img className="product-details__image" src={product.image} alt={product.name} />
        </div>
        <div className="product-details__content">
          <h1 className="product-details__title">{product.name}</h1>
          <div className="product-details__rating">
            {[...Array(5)].map((_, i) => (
              <span
                key={i}
                className={`product-details__rating-star ${
                  i < Math.floor(product.rating) ? "product-details__rating-star--filled" : ""
                }`}
              >
                {i < Math.floor(product.rating) ? "★" : "☆"}
              </span>
            ))}
            <span className="product-details__rating-count">({product.rating})</span>
          </div>
          <p className="product-details__price">₹{product.price}</p>
          {/* Description Toggle */}
          <div className="product-details__description-toggle">
            <span>Description</span>
            <button
              className="product-details__toggle-btn"
              onClick={() => setShowDescription(!showDescription)}
            >
              {showDescription ? "−" : "+"}
            </button>
          </div>
          {showDescription && (
            <p className="product-details__description">{product.description}</p>
          )}
          {/* Quantity Selector and Add to Cart */}
          <div className="product-details__quantity">
            <button
              className="product-details__quantity-btn"
              onClick={() => handleQuantityChange(-1)}
            >
              −
            </button>
            <span className="product-details__quantity-value">{quantity}</span>
            <button
              className="product-details__quantity-btn"
              onClick={() => handleQuantityChange(1)}
            >
              +
            </button>
          </div>
          <div className="product-details__action-buttons">
            <button className="product-details__add-to-cart" onClick={addToCart}>
              Add to Cart
            </button>
            <button
              className="product-details__buy-now"
              onClick={() => (window.location.href = `/checkout/${product.id}`)}
            >
              Buy Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails; 